import { Button, Divider, TableCell, TableRow } from "@mui/material"
import { setSetting } from "./controller/setSetting"
import { BoundSwitch, BoundTextField, BoundTypography } from "lib/@components/binding/bound-components"
import { Bound } from "lib/@components/binding/Bound"
import { useState } from "react"
import { clone } from "lib/clone"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { BoundStandardSelector } from "lib/@components/combos/standard-selector"
import { uniqueId } from "library/database/split-id.mjs"

export function SettingsRow({ setting }) {
    const { type } = setting

    if (type === "boolean") {
        setting.value = !!setting.value
    }
    if (type === "list") {
        if (!Array.isArray(setting.options)) {
            setting.options = setting.options ? [setting.options] : []
        }
    }
    const [currentValue] = useState(clone(setting))
    const [isUpdated, setIsUpdated] = useState(false)
    const { target } = useBoundContext()

    const settingId = uniqueId(setting?._id)
    return (
        <Bound onChange={settingIsUpdated}>
            <TableRow sx={{ padding: 0, margin: 2 }}>
                <TableCell style={{ verticalAlign: "top", width: 160 }}>
                    <BoundTypography transformIn={(v) => v.split(":")[0]} field="_id" />
                </TableCell>
                <TableCell>
                    {type === "boolean" && <BoundSwitch default={false} field="value" />}
                    {type === "list" && (
                        <BoundStandardSelector
                            options={currentValue?.options?.map((o) => ({ value: o, label: o }))}
                            field="value"
                        />
                    )}
                    {type !== "boolean" && target.type !== "list" && (
                        <BoundTextField rows={4} field="value" data-cy={`setting-row-text-input-${settingId}`} />
                    )}
                </TableCell>
                <TableCell sx={{ width: 80 }}>
                    <Button
                        disabled={!isUpdated}
                        variant="contained"
                        onClick={writeSetting}
                        data-cy={`setting-row-button-${settingId}`}
                    >
                        Update
                    </Button>
                </TableCell>
            </TableRow>
            {target.comment && (
                <TableRow sx={{ padding: 0, margin: 0 }}>
                    <TableCell style={{ verticalAlign: "top" }} />
                    <TableCell style={{ verticalAlign: "top" }} colSpan={2}>
                        <BoundTypography field="comment" />
                    </TableCell>
                </TableRow>
            )}
            <TableRow>
                <TableCell style={{ verticalAlign: "top" }} colSpan={3}>
                    <Divider />
                </TableCell>
            </TableRow>
        </Bound>
    )

    async function writeSetting() {
        const updatedSetting = { ...currentValue, value: target.value }
        await setSetting(updatedSetting)
        currentValue.value = updatedSetting.value
        setIsUpdated(false)
    }

    function settingIsUpdated() {
        if (type === "boolean") {
            setIsUpdated(!!currentValue.value !== !!target.value)
            return
        }
        const currentValueStr = String(currentValue.value)
        const targetValueStr = String(target.value)
        setIsUpdated(currentValueStr !== targetValueStr)
    }
}
